import { constants } from "@newsela/angelou";

const { ui } = constants.colors;
const white = ui.white[500];

export const root = {
  height: "256px",
};

export const textContainer = {
  position: "relative",
  height: "100%",
  maxHeight: "215px",
  overflow: "hidden",

  "&:before": {
    content: '""',
    width: "100%",
    height: "100%",
    position: "absolute",
    left: 0,
    top: 0,
    background: `linear-gradient(0deg, ${white} 24.48%, rgba(255, 255, 255, 0) 100%)`,
    pointerEvents: "none",
    zIndex: 1,
  },

  img: {
    opacity: "20%",
  },
};
